// search 
const openSearch = document.getElementById('open-search-button');
const searchIcon = document.querySelector('.header-search-open');
const closeSearch = document.querySelector('.header-search-close');
const headerSearch = document.getElementById('header-search');
const headerSearchInput = headerSearch.querySelector('input');

// open search
openSearch.addEventListener('click', () => {

    // toggle the active class
    openSearch.classList.toggle('active');

    // toggle active class on header search
    headerSearch.classList.toggle('active');

    // set focus on input if header search is active
    if (headerSearch.classList.contains('active')) {
        headerSearchInput.focus();
        // clear input value
        headerSearchInput.value = '';
    }

    // toggle aria expanded
    const expanded = openSearch.getAttribute('aria-expanded') === 'true' || false;
    openSearch.setAttribute('aria-expanded', !expanded);

    // toggle the hidden class
    searchIcon.classList.toggle('hidden');
    closeSearch.classList.toggle('hidden');
    
});

// on escape key close search
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && headerSearch.classList.contains('active')) {
        openSearch.click();
    }
});